import {Component, Input} from '@angular/core';
import {FilterDefaultComponent} from "../filter-default/filter-default.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FiltersService} from "../../filters.service";
import {FormControl} from "@angular/forms";
import {FilterBlock} from "../filter-block";
import {FilterModalComponent} from "../filter-modal/filter-modal.component";
import {Filter} from "../filter-item/filter";
import {distinctUntilChanged} from "rxjs/internal/operators";
import {TranslateService} from "../../../../../shared/translate.service";

@Component({
  selector: 'app-filter-select',
  templateUrl: './filter-select.component.html',
  styleUrls: ['./filter-select.component.css']
})
export class FilterSelectComponent extends FilterDefaultComponent {

  selectedBlock: FilterBlock;

  selectedBlockField = new FormControl();

  @Input() blockId: string = 'NoId';

  constructor(public translator: TranslateService, modalService: NgbModal, public filtersService: FiltersService) {
    super(translator, modalService, filtersService);
  }

  ngOnInit(): void {
    this.selectedBlockField.setValue(this.getInitValue());
    this.doSelect(this.getInitValue(), false);
    super.ngOnInit();
    this.selectedBlockField.valueChanges.pipe(distinctUntilChanged()).subscribe(filter => this.doSelect(filter, true));
  }

  getBaseBlock() {
    return this.selectedBlock;
  }

  private getInitValue() {
    const selectedFilter = this.filtersService.localFilters.get(this.filterBlock.filterConfig.name);
    let childBlock;
    if (selectedFilter) {
      childBlock = this.filterBlock.childFilterBlocks.find(childFilterBlock => childFilterBlock.filterConfig.name == selectedFilter.value);
    }
    if (!childBlock) {
      childBlock = this.filterBlock.childFilterBlocks[0];
    }
    return childBlock;
  }

  private doSelect(childBlock: FilterBlock, refresh: boolean) {
      this.filters.value.forEach(filter => {
        filter.selected = false;
        filter.skip = false;
      });
      if (childBlock) {
        this.filters.next(childBlock.filters);
        this.selectedBlock = childBlock;
        if (refresh) {
          this.filtersService.appendLocalFilter(new Filter({field: this.filterBlock.filterConfig.name, value: childBlock.filterConfig.name}));
          this.filtersService.navigateByFilters();
        }
      }
  }
}
